import { FC, useCallback, useMemo } from "react";
import { ContactButtonItem } from "./styles";
import { ContactButtonContainer } from "./styles";
import { Status } from "@brg/api";
import { Skeleton } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { CreateLinkTo } from "shared/constants/linkTo";

const canContact = (statusTags: Status[]): boolean => {
    return statusTags.some((status) => !!status?.canContact)
}

export const ContactButton: FC<{ statusTags: Status[], isLoadingStatusTags: boolean, designerId: string }> = ({ statusTags, isLoadingStatusTags, designerId }) => {
    const { t, i18n: { language }} = useTranslation()

    const text  = useMemo(() => {
        return language === 'ru' ? 'Связаться' : 'Contact'
    }, [language])

    const goToForm = useCallback(() => {
        window.open(`/contact-form/${designerId}/${statusTags.find((status) => status.canContact)?.formId}`, '_self')
    }, [designerId, statusTags])

    if (isLoadingStatusTags) {
        return <Skeleton width={68} height={20} />
    }

    if (statusTags.length === 0 || !canContact(statusTags)) {
        return null
    }

    return (
        <ContactButtonContainer>
            <ContactButtonItem onClick={goToForm}>{text}</ContactButtonItem>
        </ContactButtonContainer>
    )
}import { FC, useCallback, useMemo } from "react";
import { ContactButtonItem } from "./styles";
import { ContactButtonContainer } from "./styles";
import { Status } from "@brg/api";
import { Skeleton } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { CreateLinkTo } from "shared/constants/linkTo";

const canContact = (statusTags: Status[]): boolean => {
    return statusTags.some((status) => !!status?.canContact)
}

export const ContactButton: FC<{ statusTags: Status[], isLoadingStatusTags: boolean, designerId: string }> = ({ statusTags, isLoadingStatusTags, designerId }) => {
    const { t, i18n: { language }} = useTranslation()

    const text  = useMemo(() => {
        return language === 'ru' ? 'Связаться' : 'Contact'
    }, [language])

    const goToForm = useCallback(() => {
        window.open(`/contact-form/${designerId}/${statusTags.find((status) => status.canContact)?.formId}`, '_self')
    }, [designerId, statusTags])

    if (isLoadingStatusTags) {
        return <Skeleton width={68} height={20} />
    }

    if (statusTags.length === 0 || !canContact(statusTags)) {
        return null
    }

    return (
        <ContactButtonContainer>
            <ContactButtonItem onClick={goToForm}>{text}</ContactButtonItem>
        </ContactButtonContainer>
    )
}